module.exports = __webpack_public_path__ + "static/media/selling-water-revenue-02.b301b4a9.jpg";